import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { HourglassTop } from '@vedmarket/ui-kit';
import Map, {NavigationControl, Marker, MapboxEvent, MapRef}  from 'react-map-gl';
import { useScaledMapLayout } from 'components/cabinet/calculator/use-scaled-map-layout';
import {MAP_TOKEN} from "../../../../../../../../../../../../api/geocoding";
import './locationMap.scss'
import MarkerIcon from './marker-icon';

const LocationMap  = ({ lng, lat } : CalculatorLocationMapProps) => {
  const { t } = useTranslation()
  const [ isLoaded, setIsLoaded ] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const mapRef = useRef<MapRef>(null)
  const mapStyle = useScaledMapLayout({ containerRef, mapRef, height: 240 })

  const changeMapLanguage = (event: MapboxEvent) => {
    const map = event.target
    map.getStyle().layers.forEach((layer) => {
      if (layer.id.endsWith('-label')) {
        map.setLayoutProperty(layer.id, 'text-field', [
          'coalesce',
          [ 'get', 'name_ru' ],
          [ 'get', 'name' ],
        ]);
      }
    });
    setIsLoaded(true);
  };

  return (
    <div
      className='invoice-location-map invoice-form__map'
      ref={containerRef}
      aria-busy={!isLoaded}
    >
      <Map
        ref={mapRef}
        initialViewState={{
          zoom: 8
        }}
        longitude={lng}
        latitude={lat}
        onLoad={changeMapLanguage}
        style={mapStyle}
        mapStyle='mapbox://styles/mapbox/streets-v11'
        mapboxAccessToken={MAP_TOKEN}>
        <NavigationControl/>
        <Marker key='invoice-location-marker' longitude={lng} latitude={lat} anchor='bottom'>
          <MarkerIcon />
        </Marker>
      </Map>
      {!isLoaded && <div className='invoice-location-map__loading' role='status'>
        <HourglassTop style={{fill: 'currentColor'}} />
        <Typography variant='body2' sx={{
          color: 'inherit',
          lineHeight: '21px',
          letterSpacing: 0,
        }}>
          {t('calc__text__main__mapLoading')}
        </Typography>
      </div>}
    </div>
  )
}

export default LocationMap
